import { useInfiniteQuery } from "@tanstack/react-query";
import clientReportsAPIs from "../api/clientReportsAPIs";

export const useGetCatalogClientAllEmpReportKeyData = ({ limit = 10, catalogId, styleId, key = "view", companyName }) => {
  return useInfiniteQuery({
    queryKey: ["getCatalogClientAllEmpReportKeyData", { limit: limit, catalogId: catalogId, styleId: styleId, key: key, companyName }],
    queryFn: ({ pageParam = 1 }) =>
      clientReportsAPIs.getCatalogClientAllEmpReportKeyData({
        pageParam,
        queryKey: ["getCatalogClientAllEmpReportKeyData", { limit: limit, catalogId: catalogId, styleId: styleId, key: key, companyName }],
      }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage < lastPage.totalPage) {
        return lastPage.nextPage + 1;
      }
      return undefined;
    },
    enabled: !!catalogId && !!styleId,
    cacheTime: 200000,
    staleTime: 200000,
    refetchOnWindowFocus: true,
  });
};
